<template>
  <div data-module="text_image_row" :data-imagecount="imageCount">
    <div class="main">
      <div class="main__content">
        <markdown class="markdown">{{data.content}}</markdown>
      </div>
    </div>
    <div class="aside">
      <div class="aside__content">
        <div v-for="(rail, i) in imageRail" class="aside__image-rail" :key="i">
          <div
            v-for="image in rail"
            :style="{ 'height': image.height, 'background-image': `url(${image.src})`, 'background-position': image.gravity }"
            class="aside__image"
            :data-primary="image.primary"
            :key="image.src"
          >
            <img :src="image.src" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'module_text_image_row',
  props: ['data'],
  computed: {
    imageCount: function() {
      return this.data.images.length;
    },
    imageRail: function() {
      const images = this.data.images;
      const rail = [];

      const primary = [];
      const secondary = [];

      images.forEach(function(image) {
        if (image.primary) {
          primary.push(image);
        } else {
          secondary.push(image);
        }
      });

      if (primary.length !== 0) {
        rail.push(primary);
      }

      rail.push(secondary);

      return rail;
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

$mobile-breakpoint: $breakpoint--default-mobile;

[data-module="text_image_row"] {
  @include spacer();
  @include grid($subgrid: true);

  @include mq($mobile-breakpoint, down) {
    margin-bottom: 3rem;
    grid-row: auto auto;

    &[data-imagecount] {
      .main {
        grid-column: 1 / span 12;
        grid-row: 1 / span 1;
      }

      .aside {
        grid-column: 1 / span 12;
        grid-row: 2 / span 2;
      }
    }
  }

  &[data-imagecount="1"] {
    .main {
      grid-column: 1 / span 5;
      grid-row: 1 / span 1;
    }

    .aside {
      grid-column: 7 / span 5;
      grid-row: 1 / span 1;
    }
  }

  &[data-imagecount="2"] {
    .main {
      grid-column: 1 / span 6;
      grid-row: 1 / span 1;
    }

    .aside {
      grid-column: 8 / span 5;
      grid-row: 1 / span 1;
    }

    .aside__content {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-template-rows: repeat(2, auto);
      grid-gap: 0 #{$layout--gutter * 2};
    }

    .aside__image-rail {
      &:nth-child(1) {
        grid-column: 1 / span 5;
        grid-row: 1 / span 1;
      }

      &:nth-child(2) {
        grid-column: 1 / span 4;
        grid-row: 2 / span 2;
      }
    }
  }

  &[data-imagecount="3"] {
    .main {
      grid-column: 9 / span 4;
      grid-row: 1 / span 1;
    }

    .aside {
      grid-column: 1 / span 7;
      grid-row: 1 / span 1;
    }

    @include mq($bp--tablet, up) {
      .aside__content {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          grid-template-rows: repeat(1, auto);
          grid-gap: 0 #{$layout--gutter * 2};
      }

      .aside__image-rail {
        &:nth-child(1) {
          grid-column: 1 / span 4;
          grid-row: 1 / span 1;
        }

        &:nth-child(2) {
          grid-column: 5 / span 3;
          grid-row: 1 / span 1;
        }
      }
    }
  }

  .aside__image {
    margin-bottom: 2rem;
    background-repeat: no-repeat;
    background-size: cover;

    img {
      display: none;
      max-width: 100%;
      margin: auto;
    }

    @include mq($bp--tablet, down) {
      width: 100%;

      background: none !important;

      &:not([data-primary]) {
        display: none;
      }

      &[data-primary] {
        height: auto !important; // override set height
      }

      img {
        display: block;
      }
    }
  }

  @include mq($bp--tablet, down) {
    &[data-imagecount="1"],
    &[data-imagecount="2"],
    &[data-imagecount="3"] {
      @include spacer();

      .main {
        grid-row: 1 / span 1;
        grid-column: 1 / -1;
      }

      .aside {
        grid-row: 2 / span 1;
        grid-column: 1 / -1;

        &__image-rail {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/text_image_row.vue